import { get } from 'lodash';
import { connect } from 'react-redux';

import PdpAttributes from 'components/PdpAttributes';
import * as actions from 'state/actions';
import { getCurrentOpenAttributeIndex } from 'state/selectors/pdp';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  const { attributes = [], sizeChart, dataTestId, pdpStorytellingEnabled } = ownProps;

  return {
    attributes,
    openAttributeIndex: getCurrentOpenAttributeIndex(state),
    sizeChart,
    dataTestId,
    pdpStorytellingEnabled,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setCurrentAttributeIndex: (index, origination) => {
    const { attributes, basicProductProperties } = ownProps;
    const accordionOpened = get(attributes, [index, 'header']);
    // this check prevents the event from sending when the accordion is closed
    if (index) {
      Rudderstack.detailsAccordionOpened({
        accordionOpened,
        ...basicProductProperties,
      });
    }

    dispatch(actions.setCurrentAttributeIndex(index, origination));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpAttributes);
